// extracted by mini-css-extract-plugin
module.exports = {"title":"OrderForm_title__jpJec","divider":"OrderForm_divider__3Ec6w","formRowContainer":"OrderForm_formRowContainer__29OVo","submitButton":"OrderForm_submitButton__2fSpC"};